import classnames from 'classnames'
import ArrowButton from '../ArrowButton/ArrowButton'

import styles from './NextArrow.module.scss'

interface NextArrowProps {
  className?: string
  onClick?: () => void
  smallerButton?: boolean
}

const NextArrow = ({ className, onClick, smallerButton = false }: NextArrowProps) => (
  <ArrowButton
    className={classnames(styles.slickNext, className)}
    isLeftArrow={false}
    onClick={onClick}
    tracking={{ disabled: true, guid: '' }}
    smallerButton={smallerButton}
  />
)

export { NextArrow }
